import React from 'react'
import { connect } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'
import { Box, Paper, Typography } from '@mui/material'
import { HourglassBottom, TrendingUp } from '@mui/icons-material'
import { classNamesK, readableTime } from '../../lib/util'
import './Above.scss'

const AboveBox = styled(Box)(
  ({ theme }) => `
  .push-order {
    &.pushed {
      background-color: ${theme.palette.player.pushed};
    }

    .text {
      color: ${theme.palette.player.order2};

      &.has-right {
        color: ${theme.palette.player.order1};
      }
    }
  }

  .push-speed {
    color: ${theme.palette.player.order2};
  }

  .user-delay {
    color: ${theme.palette.player.userDelay};
  }

  .cons-correct, .pass-seat {
    color: ${theme.palette.player.additional}
  }
`
)

const Above = ({ player, order, delay, score, rule, users }) => {
  const theme = useTheme()

  const user = users.get(player)

  const failed = order === -2
  const pushed = failed || order > 0
  const hasRight = order > 0 && order <= rule.right.num

  const userDelay = (
    <Box className="user-delay">
      <Box className="title">
        <HourglassBottom sx={{ transformOrigin: 'left', transform: 'scale(0.7)' }} />
      </Box>
      <Box className="content">
        <Box className="value">{user.delay}</Box>
        <Box className="unit">ms</Box>
      </Box>
    </Box>
  )

  const showConsCorrect = rule.player.specialCorrect.consBonus && score.consCorrect > 0

  const consCorrect = (
    <Box className="cons-correct">
      <Box className="title">
        <TrendingUp sx={{ transformOrigin: 'bottom left', transform: 'scale(0.7)' }} />
      </Box>
      <Box className="content">
        {score.consCorrect}
      </Box>
    </Box>
  )

  const showPassSeat = rule.player.specialCorrect.passQuiz && score.passSeat

  const passSeat = (
    <Box className="pass-seat">通過席</Box>
  )

  const extComponent = (
    <Box className="ext">
      {showConsCorrect && consCorrect}
      {showPassSeat && passSeat}
    </Box>
  )

  return (
    <AboveBox className="above">
      <Paper elevation={theme.palette.player.elevation}
             className={classNamesK('push-order', { pushed })}>
        <Typography align="center"
                    className={classNamesK('text', { hasRight, failed })}>
          {order === -2 ? 'X' : order > 0 && order}
        </Typography>
      </Paper>
      {user.delay > 0 && userDelay}
      <Box className="push-speed">
        <Typography variant="caption">
          {delay >= 0 && readableTime(delay)}
        </Typography>
      </Box>
      {extComponent}
    </AboveBox>
  )
}

export default connect(
  state => ({
    rule: state.rule,
    users: state.users
  })
)(Above)
